import DatePicker, { DatePickerProps, registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ja } from 'date-fns/locale';

const style = {
  layout: {
    position: 'relative' as const,
    display: 'flex',
    alignItems: 'center',
    borderBottom: 'solid 0.1rem #ccc',
    fontSize: '1.6rem',
    cursor: 'pointer',
    '& .react-datepicker__input-container': {
      height: '2rem',
    },
    '& .react-datepicker__input-container > input': {
      border: 'none !important',
      background: 'none',
      height: '2rem',
      fontSize: '1.6rem',
    },
  },
  icon: {
    position: 'absolute' as const,
    display: 'inlineBlock',
    top: 'calc(50% - 0.8rem)',
    right: '0',
    width: '1.6rem',
    height: '1.6rem',
    color: '#888888',
  },
};

const SelectDate = (props: DatePickerProps) => {
  registerLocale('ja', ja);

  return <div css={style.layout}>
    <img src='/image/icon/calendar.svg' css={style.icon} />
    <DatePicker
      {...props}
      dateFormat='yyyy/MM/dd'
      locale='ja'
    />
  </div>;
};

export default SelectDate;
